import React from 'react';
import { CartItemType } from '@base/cart/interface';
import Link from '@base/lib/ThemeLink';

type CartItemNameProps = {
    className?: string;
    item: CartItemType;
    batchActive?: boolean;
};

const CartItemName: React.FC<CartItemNameProps> = props => {
    const {
        className,
        item: { productName, productUrl },
        batchActive = false
    } = props;
    return (
        <div className={className}>
            {batchActive ? productName : (
                <Link href={productUrl}>
                    {productName}
                </Link>
            )}
        </div>
    );
};

export default CartItemName;